import React from 'react';
import { motion } from 'framer-motion';
import { Download, Play, Apple } from 'lucide-react';

const HeroSection = () => {
  return (
    <section id="about" className="hero-section">
      {/* Animated Metro Background */}
      <div className="metro-background">
        <div className="metro-grid">
          {[...Array(20)].map((_, i) => (
            <motion.div
              key={i}
              className="metro-node"
              style={{
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 3}s`
              }}
              animate={{
                scale: [1, 1.2, 1],
                opacity: [0.3, 1, 0.3]
              }}
              transition={{
                duration: 3,
                repeat: Infinity,
                delay: Math.random() * 2
              }}
            />
          ))}
          {[...Array(15)].map((_, i) => (
            <motion.div
              key={`line-${i}`}
              className="metro-line"
              style={{
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100}%`,
                width: `${Math.random() * 200 + 100}px`,
                transform: `rotate(${Math.random() * 360}deg)`
              }}
              animate={{
                opacity: [0.1, 0.6, 0.1]
              }}
              transition={{
                duration: 4,
                repeat: Infinity,
                delay: Math.random() * 3
              }}
            />
          ))}
        </div>
      </div>

      <div className="container">
        <motion.div
          className="hero-content"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          {/* Logo */}
          <motion.div
            className="logo-container"
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <div className="logo">
              <div className="logo-icon">
                <img src="/app_icon.png" alt="MetroRahi" />
              </div>
              <h1 className="logo-text">MetroRahi</h1>
            </div>
          </motion.div>

          {/* Tagline */}
          <motion.h2
            className="tagline"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
          >
            Navigate Smarter. Travel Faster.
          </motion.h2>

          {/* Description */}
          <motion.p
            className="hero-description"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.6 }}
          >
            Experience effortless real-time navigation with smart station alerts, 
            live location sharing, and instant disruption notifications.
          </motion.p>
          
          <motion.p
            className="company-tagline"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.8 }}
          >
            A product of <a href="https://resiara.com" target="_blank" rel="noopener noreferrer" className="company-link"><strong>Resiara Software Pvt. Ltd.</strong></a>
          </motion.p>

          {/* CTA Buttons */}
          <motion.div
            className="cta-buttons"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.8 }}
          >
            <motion.a
              href="https://play.google.com/store/apps/details?id=com.resiara.metrorahi"
              target="_blank"
              rel="noopener noreferrer"
              className="cta-button play-store"
              whileHover={{ scale: 1.05, y: -2 }}
              whileTap={{ scale: 0.95 }}
            >
              <Play className="button-icon" />
              <span>Download on Play Store</span>
            </motion.a>
            
            <motion.a
              href="https://apps.apple.com/in/app/metrorahi/id6752489811"
              target="_blank"
              rel="noopener noreferrer"
              className="cta-button app-store"
              whileHover={{ scale: 1.05, y: -2 }}
              whileTap={{ scale: 0.95 }}
            >
              <Apple className="button-icon" />
              <span>Download on App Store</span>
            </motion.a>
          </motion.div>

          {/* Stats */}
          <motion.div
            className="hero-stats"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 1.0 }}
          >
            <div className="stat">
              <span className="stat-number">5+</span>
              <span className="stat-label">Major Cities</span>
            </div>
            <div className="stat">
              <span className="stat-number">1K+</span>
              <span className="stat-label">Active Users</span>
            </div>
            <div className="stat">
              <span className="stat-number">99.0%</span>
              <span className="stat-label">Accuracy</span>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default HeroSection;
